export default __webpack_public_path__ + "c001ae69635c295e634f529e6801cf8e.png";